<template>
    <v-main class="loader">
        <square></square>
    </v-main>
</template>

<script>
    export default {
        name:'app-loader',
    }
</script>

<style lang="scss">
    .loader{
        position: fixed;
        bottom: 0;
        height: 100%;
        left: 0;
        right: 0;
        top: 0;
        width: 100%;
        display:block;
        margin: 0 auto;
        overflow: hidden;
        z-index: 9999;
        background: var(--v-background-base);
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        align-items: center;
        justify-content: center;
        .vertical-center {
            margin: 0;
            position: absolute;
            top: 50%;
            -ms-transform: translateY(-50%);
            transform: translateY(-50%);
        }
    }
</style>
